import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TutorialVideo, TutorialCategory } from "../api/tutorial.api";

export type TTutorialState = {
  videos: TutorialVideo[];
  categories: TutorialCategory[];
  isLoading: boolean;
};

const initialState: TTutorialState = {
  videos: [],
  categories: [],
  isLoading: false,
};

const tutorialSlice = createSlice({
  name: "tutorial",
  initialState,
  reducers: {
    setTutorialVideos: (state, action: PayloadAction<TutorialVideo[]>) => {
      state.videos = action.payload;
    },
    setTutorialCategories: (state, action: PayloadAction<TutorialCategory[]>) => {
      state.categories = action.payload;
    },
    setTutorialLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    clearTutorial: (state) => {
      state.videos = [];
      state.categories = [];
      state.isLoading = false;
    },
  },
});

export const {
  setTutorialVideos,
  setTutorialCategories,
  setTutorialLoading,
  clearTutorial
} = tutorialSlice.actions;

export default tutorialSlice.reducer;
